import React from 'react'

const PendingIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1199_20756"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="13"
        height="13"
      >
        <rect width="13" height="13" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1199_20756)">
        <path
          d="M4.33594 7.04427H8.68281C8.83628 7.04427 8.96267 6.99227 9.06198 6.88827C9.16129 6.78463 9.21094 6.65608 9.21094 6.5026C9.21094 6.34913 9.15894 6.2204 9.05494 6.1164C8.9513 6.01276 8.82274 5.96094 8.66927 5.96094H4.3224C4.16892 5.96094 4.04253 6.01276 3.94323 6.1164C3.84392 6.2204 3.79427 6.34913 3.79427 6.5026C3.79427 6.65608 3.84609 6.78463 3.94973 6.88827C4.05373 6.99227 4.18247 7.04427 4.33594 7.04427ZM6.5026 11.9193C5.7533 11.9193 5.04913 11.777 4.3901 11.4924C3.73108 11.2082 3.15781 10.8224 2.67031 10.3349C2.18281 9.8474 1.79697 9.27413 1.51277 8.6151C1.22822 7.95608 1.08594 7.25191 1.08594 6.5026C1.08594 5.7533 1.22822 5.04913 1.51277 4.3901C1.79697 3.73108 2.18281 3.15781 2.67031 2.67031C3.15781 2.18281 3.73108 1.79678 4.3901 1.51223C5.04913 1.22803 5.7533 1.08594 6.5026 1.08594C7.25191 1.08594 7.95608 1.22803 8.6151 1.51223C9.27413 1.79678 9.8474 2.18281 10.3349 2.67031C10.8224 3.15781 11.2082 3.73108 11.4924 4.3901C11.777 5.04913 11.9193 5.7533 11.9193 6.5026C11.9193 7.25191 11.777 7.95608 11.4924 8.6151C11.2082 9.27413 10.8224 9.8474 10.3349 10.3349C9.8474 10.8224 9.27413 11.2082 8.6151 11.4924C7.95608 11.777 7.25191 11.9193 6.5026 11.9193Z"
          fill="#FFC849"
        />
      </g>
    </svg>
  )
}

export default PendingIcon
